/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 07.02.13, 14:59
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { Localize } from "../utils/Localize";

import { AbstractTextContentVO } from "./AbstractTextContentVO";

/**
 *
 */
export class LocalizedNumberVO extends AbstractTextContentVO {
    public static NAME: string = "LocalizedNumberVO";

    private _numberValue: number = NaN;
    private _compact: boolean = false;
    private _fractionalDigits: number = 0;
    private _isRTL: boolean = false;

    constructor(numberValue: number = NaN, compact: boolean = false, fractionalDigits: number = 0, isRTL: boolean = false) {
        super();

        this._numberValue = numberValue;
        this._compact = compact;
        this._fractionalDigits = fractionalDigits;
        this._isRTL = isRTL;
    }

    public get numberValue(): number {
        return this._numberValue;
    }

    public set numberValue(value: number) {
        this._numberValue = value;

        this.propertyChangedSignal.dispatch();
    }

    public get compact(): boolean {
        return this._compact;
    }

    public set compact(value: boolean) {
        this._compact = value;

        this.propertyChangedSignal.dispatch();
    }

    public get fractionalDigits(): number {
        return this._fractionalDigits;
    }

    public set fractionalDigits(value: number) {
        this._fractionalDigits = value;

        this.propertyChangedSignal.dispatch();
    }

    public get isRTL(): boolean {
        return this._isRTL;
    }

    public set isRTL(value: boolean) {
        this._isRTL = value;
    }

    public compose(): string {
        return Localize.number(this._numberValue, this._compact, this._fractionalDigits, this._isRTL);
    }

    public toString(): string {
        return (
            LocalizedNumberVO.NAME +
            ", numberValue: " +
            this._numberValue +
            ", compact: " +
            this._compact +
            ", fractionalDigits: " +
            this._fractionalDigits +
            ", isRTL: " +
            this._isRTL
        );
    }
}
